import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title = "UIQuarter - Static Analysis CLI for UI Codebases",
    description = "Open-source CLI that analyzes UI codebases and generates optimized context files for AI coding assistants. 20 analyzers, 13 commands, 7 AI targets.",
    keywords = "static analysis, UI codebase, AI context, CLI tool, CLAUDE.md, cursorrules, code analysis, React, Vue, Svelte, Angular, Next.js, developer tools, open source",
    image = "https://uiquarter.com/web-app-manifest-512x512.png",
    url = "https://uiquarter.com",
    type = "website",
    author = "UIQuarter",
    noindex = false,
    structuredData
}) => {
    const siteTitle = "UIQuarter";
    const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;

    const defaultStructuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": title,
        "description": description,
        "url": url,
        "isPartOf": {
            "@type": "WebSite",
            "name": siteTitle,
            "url": "https://uiquarter.com"
        },
        "inLanguage": "en-US",
        "potentialAction": {
            "@type": "ReadAction",
            "target": url
        }
    };

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="title" content={fullTitle} />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content={author} />

            {/* Robots */}
            <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"} />
            <meta name="googlebot" content={noindex ? "noindex, nofollow" : "index, follow, max-video-preview:-1, max-image-preview:large, max-snippet:-1"} />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={title} />
            <meta property="og:site_name" content={siteTitle} />
            <meta property="og:locale" content="en_US" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />

            {/* Additional Meta Tags */}
            <meta name="format-detection" content="telephone=no" />
            <meta name="theme-color" content="#FF3366" />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(structuredData || defaultStructuredData)}
            </script>
        </Helmet>
    );
};

export default SEO;
